export const STATICCODESERVICE = {
    IDENTIFICATION_TYPE_MYKAD: "MYKAD",
    IDENTIFICATION_TYPE_MYKID: "MYKID",
    IDENTIFICATION_TYPE_THAIID: "THAIID",
    IDENTIFICATION_TYPE_PASSPORT: "PP",
    GENDER_MASTER_MALE: "MALE",
    GENDER_MASTER_FEMALE: "FEMALE",
    COUNTRY_MALAYSIA: "MYS",
    COUNTRY_THAILAND: "THA",
    OTHERS: "OTHERS"
}